import { Component, Input, OnInit } from '@angular/core';
import { Audience } from 'src/app/models/services/audience';
import { IdentifiersTypes } from 'src/app/models/services/identifiersTypes.enum';
import { AudiencesService } from 'src/app/services/audiences/audiences.service';

@Component({
  selector: 'audience-info-block',
  templateUrl: './audience-info-block.component.html',
  styleUrls: ['./audience-info-block.component.sass']
})
export class AudienceInfoBlockComponent implements OnInit {

  @Input()
  audience: Audience;

  constructor(private audiencesService: AudiencesService) { }

  ngOnInit(): void {
  }

  getIdentifiersCountsSorted = (): { key: number, value: number }[] => {
    const result = new Map<number, number>();

    // Sort identifiers counts including home ids
    const sortedIdentifierIds = [IdentifiersTypes.HashedEmail, IdentifiersTypes.MAID, IdentifiersTypes.CTV, -1, IdentifiersTypes.WAMCookie, IdentifiersTypes.TTDCookie, IdentifiersTypes.XandrCookie];
    sortedIdentifierIds.forEach(id => {
      if (id == -1)
        result.set(id, this.audience.homesCount ?? 0);
      else
        result.set(id, this.audience.identifiersCounts[id] ?? 0);
    });

    return Array.from(result.entries()).map(([key, value]) => ({ key, value }));
  }
}
